<template>
    <v-container class="ma-0 pa-0">
        <v-row class="py-10 px-8 mb-12">
            <strong>Filtros</strong>
            <v-spacer></v-spacer>
            <v-btn @click="deleteFilters" small class="elevation-0" style="border:solid 1px #dddddd;">
                <v-icon small class="mr-1">mdi-filter-off</v-icon>Limpiar
            </v-btn>
            
            <div class="mt-4">
                Fecha
                <v-menu offset-y :close-on-content-click="closeDatePicker(payroll.date)">
                    <template v-slot:activator="{ on, attrs }">
                        <v-text-field :rules="[v => !!v || 'Campo requerido']" clearable required v-model="payroll.date" label="Fecha" prepend-icon="mdi-calendar" v-bind="attrs" readonly v-on="on"></v-text-field>
                    </template>
                    <v-date-picker v-model="payroll.date" range></v-date-picker>
                </v-menu>
            </div>

            <v-autocomplete @keydown.enter="filter()" v-model="payroll.user_id" :items="userLists" item-text="name" item-value="id" attach chips label="Personal" multiple>
            </v-autocomplete>

            <v-autocomplete @keydown.enter="filter()" v-model="payroll.job_position" :items="positions" attach chips label="Área" multiple>
            </v-autocomplete>

            <v-autocomplete @keydown.enter="filter()" v-model="payroll.sub_job_position" :items="subPositions" attach chips label="Puesto" multiple>
            </v-autocomplete>

            <v-select
                v-model="payroll.is_stamped"
                :items="stampedOptions"
                item-text="text"
                item-value="value"
                clearable
                label="Timbrado"
            ></v-select>

            <v-text-field @keydown.enter="filter()" v-model="payroll.notes" label="Notas"></v-text-field>

        </v-row>
        <v-card style="position:absolute; bottom:0; width:100%;" tile color="primary">
            <v-list-item link @click="filter()" dark>
                <v-list-item-content>
                    <strong>Filtrar (0)</strong>
                </v-list-item-content>
            </v-list-item>    
        </v-card>
    </v-container>
</template>
<script>
  export default {
    props:{
        company:Object
    },
    data: () => ({
        payroll:{
            notes:'',
            user_id:'',
            sub_job_position:'',
            job_position:'',
            is_stamped:'',
            date:[],
        },
        stampedOptions:[
            { text:'Timbradas', value:'1' },
            { text:'Sin timbrar', value:'0' },
        ],
        subPositions:[
            'Administración',
            'Asistente dirección',
            'Contabilidad', 
            'Almacén',
            'Calidad',
            'Logística', 
            'Montacargas',
            'Cobranza',
            'Compras', 
            'Ecommerce',
            'Publicidad',
            'Ventas', 
            'Ventas Industria',
            'App',
            'Trapo'
        ],
        positions:[
            'Administración',
            'Almacén',
            'Chofer Ejecutivo',
            'Chofer Repartidor',
            'Comercial',
            'Dirección',
            'Producción',
            'Sistemas'
        ],
    }),
    created(){
        if(localStorage.getItem('selectorFiltersPayrolls')!=undefined){
            this.payroll = JSON.parse(localStorage.getItem('selectorFiltersPayrolls'))
        }
    },
    computed: {
        userLists(){
            return this.$store.state.user.users;
        }, 
    },
    methods: {
        closeDatePicker(dates){
            if(dates!=undefined && dates.length==2){
                return true
            }else{
                return false
            }
        },
        filter(){
            var count = 0
            var filter = ''
            //abierto
            if(this.payroll.notes!=''){
                count = count+1
                filter = filter + '&filter[notes]='+this.payroll.notes
            }
            //date
            if(this.payroll.date!=null && this.payroll.date!=undefined && this.payroll.date.length==2){
                count = count+1
                filter = filter + '&filter[date_between]=' + this.payroll.date[0] + ',' + this.payroll.date[1]
            }
            //multiples
            if(this.payroll.user_id!=undefined && this.payroll.user_id.length>0){
                count = count+1
                filter = filter + '&filter[user_id]='
                const userLength = this.payroll.user_id.length
                for(let i=0; i<userLength; i++){
                    filter = filter + this.payroll.user_id[i]
                    if(userLength>1 && i<userLength-1){
                        filter = filter + ','
                    }
                }
            }
            if(this.payroll.sub_job_position!=undefined && this.payroll.sub_job_position.length>0){
                count = count+1
                filter = filter + '&filter[user.sub_job_position]='
                const subPositionLength = this.payroll.sub_job_position.length
                for(let i=0; i<subPositionLength; i++){
                    filter = filter + this.payroll.sub_job_position[i]
                    if(subPositionLength>1 && i<subPositionLength-1){
                        filter = filter + ','
                    }
                }
            }
            if(this.payroll.job_position!=undefined && this.payroll.job_position.length>0){
                count = count+1
                filter = filter + '&filter[user.job_position]='
                const jobPositionLength = this.payroll.job_position.length
                for(let i=0; i<jobPositionLength; i++){
                    filter = filter + this.payroll.job_position[i]
                    if(jobPositionLength>1 && i<jobPositionLength-1){
                        filter = filter + ','
                    }
                }
            }
            if(this.payroll.is_stamped!==undefined && this.payroll.is_stamped!==null && this.payroll.is_stamped!==''){
                count = count+1
                filter = filter + '&filter[is_stamped]=' + this.payroll.is_stamped
            }
            localStorage.setItem('selectorFiltersPayrolls', JSON.stringify(this.payroll));
            localStorage.setItem('filtersPayroll', JSON.stringify(filter.slice(1,filter.length)));
            localStorage.setItem('filtersPayrollsLength', count)
            this.$nextTick(() => {
                this.$store.dispatch('payroll/getTotals')
                this.$emit("filtersPayroll", false);
            })
        },
        deleteFilters(){
            this.payroll = {
                notes:'',
                user_id:'',
                sub_job_position:'',
                job_position:'',
                is_stamped:'',
                date:[],
            },
            localStorage.removeItem("filtersPayrollsLength")
            localStorage.removeItem("filtersPayroll")
            localStorage.removeItem("selectorFiltersPayrolls")
            this.$nextTick(() => {
                this.$store.dispatch('payroll/getTotals')
                this.$emit("filtersPayroll", false);
            })
        }
    }
  }
</script>
